import {
  container,
//cardTitle,
//whiteColor,
//grayColor,
  ts_main
} from "assets/jss/material-dashboard-pro-react.jsx";

const HistoryChangeStyle = theme => ({
  container: {
    ...container,
    backgroundColor: "#FFFFFF",
    zIndex: "4",
    [theme.breakpoints.down("sm")]: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  },
  labelHeader: {
    marginTop        : 10,
    marginBottom     : 10,
    fontSize         : "1.7rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#FFDD00",
    textAlign        : "center",
  },
  logo: {
    margin           : "1rem 0",
    "& img"          : {
      width   : "25%",
      display : "block",
      margin  : "auto"
    },
    "& span"          : {
      width        : "100px",
      height       : "1px",
      borderBottom : "3px solid " + ts_main[3],
      display      : "block",
      margin       : "1rem auto"
    }
  },
  //-----
  //label
  //-----
  History3_lbl_headerLabel01: {
    marginTop        : 10,
    marginBottom     : 0,
    fontSize         : "1.2rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  History3_lbl_headerLabel02: {
    marginTop        : 10,
    marginBottom     : 0,
    fontSize         : "1.2rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  History3_lbl_headerLabel03: {
    marginTop        : 10,
    marginBottom     : 0,
    fontSize         : "1.2rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "left",
    "vertical-align" : "middle",
  },
  //---------
  //TextField
  //---------
  textField1: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField2: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField3: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField4: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  textField5: { marginTop:10, marginBottom:10, input:{ color : "303030" } },
  //--------
  //DropDown
  //--------
  picker1_textFieldLabel1 : { marginTop:10, marginBottom:10, },
  picker2_textFieldLabel1 : { marginTop:10, marginBottom:10, },
  picker3_textFieldLabel1 : { marginTop:10, marginBottom:10, },
  picker4_textFieldLabel1 : { marginTop:10, marginBottom:10, },
  picker5_textFieldLabel1 : { marginTop:10, marginBottom:10, },
  picker2b_textFieldLabel1: { marginTop:10, marginBottom:10, },
  picker3b_textFieldLabel1: { marginTop:10, marginBottom:10, },
  picker4b_textFieldLabel1: { marginTop:10, marginBottom:10, },
  picker5b_textFieldLabel1: { marginTop:10, marginBottom:10, },
  //----------
  //PleaseWait
  //----------
  pleaseWait: {
    marginTop        : 50,
  //marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //---------------
  //PleaseWaitPopup
  //---------------
  pleaseWaitPopup: {
    marginTop        : 0,
    marginBottom     : 0,
    fontSize         : "1rem",
    fontFamily       : '"Helvetica"',
    fontWeight       : "300",
    color            : "#303030",
    textAlign        : "center",
    overflow         : "hidden",
    display          : "flex",
    alignItems       : "center",
    justifyContent   : "center",
  },
  //-------
  //Buttons
  //-------
  yellowButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 50,
    marginBottom     : 20,
    color            : "#303030",
    backgroundColor  : "#FFDD00",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
    "&:focus"        : { fontWeight:"600", color:"#303030", background: "#FFDD00 !important"},
  },
  backButton: {
    fontSize         : "0.9rem",
    textTransform    : "none",
    marginTop        : 0,
    marginBottom     : 20,
    color            : "#0000ff",
    backgroundColor  : "rgba(255, 255, 255, 1.0)",
    width            : "100%",
    'border-radius'  : "25px",
    "&:hover"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
    "&:focus"        : { fontWeight:"600", color:"#0000ff !important", background: "rgba(255, 255, 255, 1.0) !important"},
  },

  popupOkButton: {
    textTransform   : "none",
    backgroundColor : "#FFDD00",
    'border-radius' : "10px"
  },
});

export default HistoryChangeStyle;
